import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const PackageComparison = () => {
  const [selectedPlan, setSelectedPlan] = useState('premium');

  const packages = [
    {
      id: 'basic',
      name: 'Paquete Básico',
      nameEn: 'Basic Package',
      price: { colones: 18000, dollars: 32 },
      frequency: 'Quincenal',
      frequencyEn: 'Bi-weekly',
      description: 'Ideal para piscinas de uso ocasional',
      features: [
        'Limpieza de superficie',
        'Aspirado básico',
        'Balanceado químico',
        'Limpieza de skimmers',
        'Reporte mensual'
      ],
      notIncluded: [
        'Limpieza de filtros',
        'Reparaciones menores',
        'Servicio de emergencia'
      ],
      popular: false,
      savings: '15% vs servicios individuales'
    },
    {
      id: 'premium',
      name: 'Paquete Premium',
      nameEn: 'Premium Package',
      price: { colones: 25000, dollars: 45 },
      frequency: 'Semanal',
      frequencyEn: 'Weekly',
      description: 'Nuestro servicio más completo y popular',
      features: [
        'Limpieza completa de superficie y paredes',
        'Aspirado profundo del fondo',
        'Balanceado químico profesional',
        'Limpieza y mantenimiento de filtros',
        'Revisión de equipos',
        'Reporte detallado semanal',
        'Productos químicos incluidos',
        'Soporte telefónico prioritario'
      ],
      notIncluded: [
        'Reparaciones mayores (cotización aparte)'
      ],
      popular: true,
      savings: '25% vs servicios individuales'
    },
    {
      id: 'platinum',
      name: 'Paquete Platinum',
      nameEn: 'Platinum Package',
      price: { colones: 35000, dollars: 65 },
      frequency: 'Semanal + Extras',
      frequencyEn: 'Weekly + Extras',
      description: 'Servicio premium con beneficios exclusivos',
      features: [
        'Todo lo incluido en Premium',
        'Limpieza mensual de azulejos',
        'Mantenimiento preventivo de equipos',
        'Reparaciones menores incluidas',
        'Servicio de emergencia 24/7',
        'Descuento en reparaciones mayores',
        'Productos químicos premium',
        'Análisis de agua especializado',
        'Garantía extendida en servicios'
      ],
      notIncluded: [],
      popular: false,
      savings: '30% vs servicios individuales'
    }
  ];

  const handleSelectPackage = (packageId) => {
    const selectedPackage = packages.find(pkg => pkg.id === packageId);
    const message = encodeURIComponent(`Hola, me interesa contratar el ${selectedPackage.name}. ¿Podrían darme más información sobre disponibilidad y proceso de contratación?`);
    window.open(`https://wa.me/50688888888?text=${message}`, '_blank');
  };

  return (
    <section className="mb-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-primary mb-4">
          Paquetes de Mantenimiento
        </h2>
        <p className="text-xl text-text-secondary max-w-3xl mx-auto">
          Ahorra hasta un 30% con nuestros paquetes de mantenimiento regular. 
          Planes diseñados para diferentes necesidades y presupuestos.
        </p>
      </div>

      {/* Package Comparison Table - Desktop */}
      <div className="hidden lg:block bg-surface rounded-lg shadow-medium overflow-hidden">
        <div className="grid grid-cols-4 gap-0">
          {/* Header Column */}
          <div className="bg-background p-6 border-r border-border">
            <h3 className="text-lg font-heading font-semibold text-text-primary mb-4">
              Características
            </h3>
          </div>

          {/* Package Headers */}
          {packages.map((pkg) => (
            <div
              key={pkg.id}
              className={`p-6 text-center border-r border-border last:border-r-0 ${
                pkg.popular ? 'bg-primary/5 border-primary/20' : 'bg-background'
              }`}
            >
              {pkg.popular && (
                <div className="inline-block bg-primary text-white px-3 py-1 rounded-full text-sm font-medium mb-3">
                  Más Popular
                </div>
              )}
              <h3 className="text-xl font-heading font-bold text-text-primary mb-2">
                {pkg.name}
              </h3>
              <div className="text-2xl font-bold text-primary mb-1">
                ₡{pkg.price.colones.toLocaleString()}
              </div>
              <div className="text-lg text-text-secondary mb-2">
                ${pkg.price.dollars}
              </div>
              <div className="text-sm text-text-secondary mb-4">
                {pkg.frequency}
              </div>
              <div className="text-xs bg-success/10 text-success px-2 py-1 rounded">
                {pkg.savings}
              </div>
            </div>
          ))}
        </div>

        {/* Features Comparison */}
        <div className="border-t border-border">
          {/* All unique features */}
          {[
            'Limpieza de superficie',
            'Aspirado del fondo',
            'Balanceado químico',
            'Limpieza de filtros',
            'Revisión de equipos',
            'Productos químicos incluidos',
            'Reporte detallado',
            'Soporte prioritario',
            'Limpieza de azulejos',
            'Reparaciones menores',
            'Servicio de emergencia 24/7',
            'Análisis especializado'
          ].map((feature, index) => (
            <div key={index} className="grid grid-cols-4 gap-0 border-b border-border last:border-b-0">
              <div className="p-4 border-r border-border bg-background">
                <span className="text-sm text-text-primary">{feature}</span>
              </div>
              {packages.map((pkg) => (
                <div key={pkg.id} className="p-4 border-r border-border last:border-r-0 text-center">
                  {pkg.features.some(f => f.toLowerCase().includes(feature.toLowerCase())) ? (
                    <Icon name="Check" size={20} className="text-success mx-auto" />
                  ) : (
                    <Icon name="X" size={20} className="text-text-secondary mx-auto" />
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* Action Buttons */}
        <div className="grid grid-cols-4 gap-0 border-t border-border">
          <div className="p-6 border-r border-border bg-background"></div>
          {packages.map((pkg) => (
            <div key={pkg.id} className="p-6 border-r border-border last:border-r-0 text-center">
              <button
                onClick={() => handleSelectPackage(pkg.id)}
                className={`w-full px-4 py-3 rounded-lg font-medium nav-transition ${
                  pkg.popular
                    ? 'bg-primary text-white hover:bg-primary/90' :'bg-surface border-2 border-primary text-primary hover:bg-primary/5'
                }`}
              >
                Seleccionar
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Package Cards - Mobile/Tablet */}
      <div className="lg:hidden space-y-6">
        {packages.map((pkg) => (
          <div
            key={pkg.id}
            className={`bg-surface rounded-lg shadow-medium overflow-hidden ${
              pkg.popular ? 'ring-2 ring-primary' : ''
            }`}
          >
            {pkg.popular && (
              <div className="bg-primary text-white text-center py-2 text-sm font-medium">
                Más Popular - {pkg.savings}
              </div>
            )}
            
            <div className="p-6">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-heading font-bold text-text-primary mb-2">
                  {pkg.name}
                </h3>
                <div className="text-3xl font-bold text-primary mb-1">
                  ₡{pkg.price.colones.toLocaleString()}
                </div>
                <div className="text-xl text-text-secondary mb-2">
                  ${pkg.price.dollars}
                </div>
                <div className="text-text-secondary mb-4">
                  {pkg.frequency}
                </div>
                <p className="text-text-secondary">
                  {pkg.description}
                </p>
              </div>

              <div className="mb-6">
                <h4 className="font-semibold text-text-primary mb-3">Incluye:</h4>
                <ul className="space-y-2">
                  {pkg.features.map((feature, index) => (
                    <li key={index} className="flex items-start space-x-2 text-sm">
                      <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
                      <span className="text-text-secondary">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {pkg.notIncluded.length > 0 && (
                <div className="mb-6">
                  <h4 className="font-semibold text-text-primary mb-3">No incluye:</h4>
                  <ul className="space-y-2">
                    {pkg.notIncluded.map((feature, index) => (
                      <li key={index} className="flex items-start space-x-2 text-sm">
                        <Icon name="X" size={16} className="text-text-secondary mt-0.5 flex-shrink-0" />
                        <span className="text-text-secondary">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              <button
                onClick={() => handleSelectPackage(pkg.id)}
                className={`w-full px-6 py-4 rounded-lg font-medium nav-transition ${
                  pkg.popular
                    ? 'bg-primary text-white hover:bg-primary/90' :'bg-surface border-2 border-primary text-primary hover:bg-primary/5'
                }`}
              >
                Seleccionar {pkg.name}
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Additional Information */}
      <div className="mt-12 bg-background rounded-lg p-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Shield" size={32} className="text-primary" />
            </div>
            <h3 className="text-lg font-heading font-semibold text-text-primary mb-2">
              Garantía de Calidad
            </h3>
            <p className="text-text-secondary text-sm">
              Todos nuestros paquetes incluyen garantía de satisfacción y reposición de servicio si no cumple expectativas.
            </p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Calendar" size={32} className="text-success" />
            </div>
            <h3 className="text-lg font-heading font-semibold text-text-primary mb-2">
              Flexibilidad
            </h3>
            <p className="text-text-secondary text-sm">
              Puedes cambiar de paquete, pausar temporalmente o cancelar con 30 días de anticipación.
            </p>
          </div>
          
          <div className="text-center">
            <div className="w-16 h-16 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Users" size={32} className="text-accent" />
            </div>
            <h3 className="text-lg font-heading font-semibold text-text-primary mb-2">
              Técnicos Certificados
            </h3>
            <p className="text-text-secondary text-sm">
              Todos nuestros técnicos están certificados y cuentan con más de 5 años de experiencia en mantenimiento de piscinas.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PackageComparison;